
import styles from "./PaintPackage.module.css";

export default function PaintPackages({ selected, packageData, handlePackageSelect }) {

    if(packageData == null) return false;

    const packages = packageData != null? (
        
        packageData.map((p, index) => (
            <div key={index} className={styles.packageContainer}>
                <div className={styles.wallPackagesTop}>
                <input type="radio" value={p.scheme} onChange={handlePackageSelect} checked={selected === p.scheme ? "checked" : ""} name="package-option" aria-labelledby="package selector" />
                <div className={styles.radioLabel}>
                    <p>{p.scheme}</p>
                </div>
                </div>
                {/* BODY */}
                <div className={styles.wallPackages}>
                    <p>Body</p>
                    <img loading="lazy" src={`https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=COLOR(!${p.bodyChamID})&type=prod&extra=(focus=300)&Size=100`} alt={p.bodyName}></img>
                    <div className={styles.packagesHeading}>{p.body}</div>
                    <div className={styles.packagesSub}>{p.bodySku}</div>
                </div>
                {/* TRIM */}
                <div className={styles.wallPackages}>
                    <p>Trim</p>
                    <img loading="lazy" src={`https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=COLOR(!${p.trimChamID})&type=prod&extra=(focus=300)&Size=100`} alt={p.trimName}></img>
                    <div className={styles.packagesHeading}>{p.trim}</div>
                    <div className={styles.packagesSub}>{p.trimSku}</div>
                </div>
                {/* DOOR */}
                <div className={styles.wallPackages}>
                    <p>Front Door</p>
                    <img loading="lazy" src={`https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=COLOR(!${p.frontDoorChamID})&type=prod&extra=(focus=300)&Size=100`} alt={p.doorName}></img>
                    <div className={styles.packagesHeading}>{p.frontDoor}</div>
                    <div className={styles.packagesSub}>{p.frontDoorSku}</div>
                </div>
            </div>
        ))
    ) : (
        <li>No packages available</li>
    );

    return (
        <div className={styles.content}>
            {packages}
        </div>
    );
}
